import React from "react";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
// import { useState } from "react";
import { Link } from "react-router-dom";
import { _auth } from "../modules/_auth";
import AuthImage from "../images/auth-image.jpg";
import AuthDecoration from "../images/auth-decoration.png";
import MaintenanceImage from "../images/maintenance.png";

import RiskLogo from "../images/risk-logo.png";
import Logo from "../images/BreachConnectLogoSidebar.png";

import Spinner from "../images/spinner.png";
import { utils } from "../modules/_utils";
import Button from "../elements/Button";
import { usePersistStore } from "../store/usestore";
import { _stripe } from "../modules/_stripe";
import { features } from "../modules/_features";
import Input from "../components/Input";
import { _navigation } from "../modules/_navigation";
import { Store } from "../layouts/store";
import useGlobalState from "../hooks/useGlobalState";
import { audit } from "../modules/_audit";
import { Preferences } from "../modules/_user_preferences";
import { Projects } from "../modules/_projects";
import { Solicitations } from "../modules/_solicitations";
import { useParams } from "react-router-dom";
import { System } from "../modules/_system";
import NotificationBanner from "../components/NotificationBanner";
import LoginBackground from "../components/LoginBackground";
import LoginCard from "../components/LoginCard";

function Signin() {
  const specialAnnouncement = false;
  const history = useHistory();
  const [maintenance, setMaintenance] = useState(false);
  const [announcement, setAnnouncement] = useState(false);
  const [announcementText, setAnnouncementText] = useState("");
  // const [isAuthenticated, setIsAuthenticated] = useState();
  const { isAuthenticated, isSuccess, profile, error, loginAsync, mfa } =
    usePersistStore();
  const [loginMessage, setLoginMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showMFA, setShowMFA] = useState(false);
  const allowedRoles = ["Manager", "Administrator", "Super Admin"];
  const [otp, setOtp] = useState();
  const [loginResponse, setLoginResponse] = useState(null);
  const [profileState, setProfileState] = useState({});
  const [token, setToken] = useState(null);
  const [navPath, setNavPath] = useState(null);
  const [tenantId, setTenantId] = useState(null);
  const [tenantCount, setTenantCount] = useState(null);
  const [accessDenied, setAccessDenied] = useState(false);
  const [fullyAuthenticated, setFullyAuthenticated] = useState(false);
  const { updateState } = useGlobalState();

  // _auth.setUserProfile({});
  // useEffect(() => {
  //   features.getFeatureFlags();
  // }, []);

  useEffect(() => {
    // Clear history by replacing it with only the login page
    window.history.pushState(null, null, window.location.href);
    window.history.replaceState(null, null, window.location.href);
  }, []);

  // useEffect(() => {
  //   console.log("loginResponse", loginResponse);
  // }, [loginResponse]);

  // useEffect(() => {
  //   console.log("loginResponse token", token);
  // }, [token]);

  // useEffect(() => {
  //   isAuthenticated && isAuthenticated === true
  //     ? setFullyAuthenticated(true)
  //     : setFullyAuthenticated(false);
  // }, [isAuthenticated]);

  useEffect(() => {
    (async () => {
      // console.log("Checking for system messages");
      let systemMessages = await System.GetSystemMessages();
      if (systemMessages) {
        // console.log("System Messages Found");
        //find a name in the result called "Maintenance" and if it is true, set the maintenance state to true
        let maintenance = systemMessages.find((m) => m.name === "Maintenance");
        if (maintenance) {
          // console.log("Maintenance message found", maintenance);
          setMaintenance(true);
        }
        let announcement = systemMessages.find(
          (m) => m.name === "Announcement"
        );
        if (announcement) {
          // console.log("Announcement message found", announcement);
          setAnnouncement(true);
          setAnnouncementText(announcement.description);
        } else {
          // console.log("No announcement message found");
        }
      }
    })();
  }, []);

  // useEffect(() => {
  //   console.log("ShowMFA changed", showMFA);
  // }, [showMFA]);

  const multiFactorAuth = async (event) => {
    event.preventDefault();
    // console.log(
    //   "mfa called",
    //   otp,
    //   loginResponse,
    //   navPath,
    //   tenantId,
    //   accessDenied
    // );

    setLoader(true);

    // let userProfile = profile;
    let userProfile = profileState; //|| _auth.getUserProfile();

    let response = await mfa(otp, token, userProfile);

    if (response) {
      // console.log("mfa response", response);
      // console.log("mfa response mfaSuccess:", isMfaSuccess, isAuthenticated);
      if (profile != false) {
        // console.info("User Profile for MFA", userProfile);
        let tenantCount = userProfile.tenantCount;
        if (tenantCount > 1) {
          proceedLogin(userProfile);
          // return history.push({
          //   state: { profile: userProfile },
          //   pathname: "/select-tenant",
          //   fullyAuthenticated: fullyAuthenticated,
          // });
        } else {
          proceedLogin(userProfile);
        }
      } else {
        // console.log("mfa no profile");
        setLoader(false);
      }
    } else {
      // console.log("no mfa response");
      setLoader(false);
      setLoginMessage("Invalid verification code. Please try again.");
    }
  };

  // const MFA = () => {
  //   console.log("Rendering MFA component", showMFA);
  //   return (
  //     <main className="bg-primary-800">
  //       <div className="relative md:flex justify-center">
  //         {/* Content */}
  //         <div className=" justify-center content-center">
  //           <div className="min-h-screen h-full flex flex-col content-center justify-center">
  //             {/* <div className="max-w-sm mx-auto px-4">
  //           <img className="max-w-18 mx-auto px-4 py-8" src={Logo} />
  //         </div> */}

  //             <div className="bg-white bg-white shadow-lg rounded-md border border-gray-200 max-w-sm mx-auto p-8 ">
  //               <h1 className="text-2xl font-bold mb-6">
  //                 {/* <ShieldCheckIcon className="inline w-8 h-8 mr-2" /> */}
  //                 <span>Let's verify it's you </span>
  //               </h1>
  //               <div className="mb-10">
  //                 We've emailed you a verification code that's good for 15
  //                 minutes. Check your email and enter your verification code
  //                 below:
  //               </div>
  //               {/* Form */}
  //               {/* <form onSubmit={multiFactorAuth}> */}
  //               <div className="space-y-4">
  //                 <div>
  //                   {/* <label
  //                   className="block text-sm font-medium mb-1"
  //                   htmlFor="password"
  //                 >
  //                   Verification Code
  //                 </label> */}
  //                   <Input
  //                     id="Otp"
  //                     value={otp}
  //                     onChange={(e) => setOtp(e.target.value)}
  //                     className="h-12 rounded w-full
  //                   focus:shadow-[inset_0px_0px_2px_0px_rgba(0,0,0,0.3)] focus:shadow-accent-500
  //                   border-gray-300 py-2 px-3 shadow-sm
  //                   hover:border-gray-400
  //                   focus:border-none  focus:ring-1 focus:ring-brand-500"
  //                     type="number"
  //                     autoComplete="off"
  //                     placeholder="Verification Code"
  //                   />
  //                 </div>
  //               </div>
  //               <div className="flex items-center justify-between mt-6 mb-4">
  //                 <Button
  //                   type="submit"
  //                   disabled={otp === undefined || otp === ""}
  //                   // class="btn bg-primary w-full hover:bg-primary-600 text-white mb-4"
  //                   fullWidth
  //                   audit={true}
  //                   action="Login"
  //                   size="lg"
  //                   color="secondary"
  //                   handleClick={multiFactorAuth}
  //                   // onClick={auth}
  //                 >
  //                   {" "}
  //                   Continue Login
  //                 </Button>
  //               </div>
  //               {/* </form> */}
  //               <Button
  //                 // type="submit"
  //                 color="outline"
  //                 className="btn bg-white w-full text-primary-600"
  //                 fullWidth
  //                 handleClick={() => {
  //                   setShowMFA(false);
  //                   setLoader(false);
  //                   setLoginMessage("");
  //                   setOtp("");
  //                   setAccessDenied(false);
  //                   // setIsAuthenticated(false);
  //                   setLoginResponse(null);
  //                   setNavPath(null);
  //                   _auth.setUserProfile({});
  //                 }}
  //               >
  //                 Cancel
  //               </Button>

  //               {/* Footer */}
  //               {/* {passwordMatched === false && (
  //                 <div className="flex items-center justify-center mt-6 text-red-500 text-sm">
  //                   Please recheck your password.
  //                 </div>
  //               )} */}
  //               {isAuthenticated === false && (
  //                 <div className="flex items-center justify-center mt-6 text-red-500 text-sm">
  //                   Check your code and try again.
  //                 </div>
  //               )}
  //               {/* <div className="pt-5 mt-6 border-t border-gray-200">
  //             <div className="text-sm">
  //               Don’t you have an account?{" "}
  //               <Link
  //                 className="font-medium text-primary-500 hover:text-primary-600"
  //                 to="/signup"
  //               >
  //                 Sign Up
  //               </Link>
  //             </div>
  //           </div> */}
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </main>
  //   );
  // };

  const proceedLogin = async (prof) => {
    // console.log("proceedLogin prof parameter", prof);
    //if the user has MFA disabled, check if they have more than one tenant
    // console.log("history.location.state.from", history.location.state?.from);
    setFullyAuthenticated(true);
    let profile = prof; // || _auth.getUserProfile();
    // console.log("proceedLogin loginResponse", profile);
    let tenantCount = profile.tenantCount;
    let newResponse = profile;
    let role = profile.companyRole;
    if (
      history.location.state?.from &&
      history.location.state?.from.includes("connections/accept")
    ) {
      //workaround for the connection accept page because
      //it doesn't require a selected tenant. It will be selected in the accept page
      tenantCount = 1;
    }
    // features.getFeatureFlags();
    let flags = await features.featureFlags();
    // console.log("Sign in auth feature flags", flags);
    if (flags) {
      updateState("flags", flags.data ? flags.data : []);
    }
    if (tenantCount > 1) {
      //if they have more than one tenant, go to tenant selection page
      let path = navPath;
      path = accessDenied ? "/access-denied" : "/select-tenant";
      // Clear browser history state
      window.history.replaceState(null, null, path);
      history.replace({
        state: {
          profile: profile,
          tenantId: tenantId,
          from: history.location.state?.from,
          isFullyAuthenticated: fullyAuthenticated,
        },
        pathname: path,
      });
    } else {
      newResponse.tenantId = profile.tenants[0].tenantId._id;
      newResponse.tenantName = profile.tenants[0].tenantId.tenantTitle;
      newResponse.tenantType = profile.tenants[0].tenantId.type;

      let isRenamed = profile.tenants[0].tenantId.isRenamed;

      newResponse.tenantRole = profile.tenants[0].role;
      profile = _auth.buildProfile(newResponse);
      setLoginResponse(profile);

      // console.log("setProfile Update user profile", profile);
      _auth.setUserProfile(profile);
      //if they have one tenant, get their stripe information
      // if (process.env.REACT_APP_NODE_ENV !== "local") {
      _stripe.getStripeData(); //get stripe data and set it in the cache. this also creates websocket connection
      // }
      let path = history.location.state?.from || _navigation.getPath(profile);
      path = accessDenied ? "/access-denied" : path;
      history.push({
        state: {
          profile: profile,
          isFullyAuthenticated: fullyAuthenticated,
        },
        pathname: path,
      });
      // if (!showOnboarding || showOnboarding === false) {
      //   //check if we need to show onboarding page
      //   console.log("sign in redirect to home");
      //   // path = "/home";
      //   path = _navigation.getPath(response);
      //   history.push({
      //     state: { profile: response },
      //     pathname: path,
      //   });
      // } else {
      //   //if they have one tenant, and they have not completed onboarding, go to onboarding page
      //   history.push({
      //     state: { profile: response },
      //     pathname: "/onboarding",
      //     // pathname: _navigation.getPath(response),
      //   });
      // }
    }
  };

  const showMFAWorkflow = (response) => {
    //if the user has MFA enabled, go to MFA page, regardless how many tenants they have
    // console.log("sign in redirect to mfa", response);
    // path = "/mfa";
    // history.push({
    //   state: { profile: response, from: path },
    //   pathname: path,
    // });
    setShowMFA(true);
  };

  const auth = async (event) => {
    setLoader(!loader);
    event.preventDefault();
    // console.log("setProfile Create initial user profile", {});
    _auth.setUserProfile({});

    var u = event.target.elements.email.value;
    var p = event.target.elements.password.value;

    let userData = {
      email: u,
      password: p,
    };

    let response = await loginAsync(userData);
    // debugger;
    let token = response.token;
    response = response.decoded;
    // console.log("loginAsync Response", token, response);
    let tenantId = null;
    let access_denied = false;
    let path = history.location.state?.from || "/home";
    if (history.location.state?.from) {
      let urlParts = history.location.state?.from.split("/");
      let projectIndex = urlParts.indexOf("project-details");
      let projectId = urlParts[projectIndex + 1];
      if (projectIndex > -1 && projectId) {
        ({ tenantId, access_denied } = await validateAndProcess(
          history,
          tenantId,
          response,
          access_denied
        ));
      } else {
        path = "/home";
      }
    }

    // console.log("loginAsync Response", response);
    // debugger;
    if (response) {
      setToken(token);
      setProfileState(response);
      setLoginResponse(response);

      // console.log("loginAsync Response", response);
      // console.log("setProfile Update user profile", response);
      // _auth.setUserProfile(response);
      audit.logAction("Login Successful");
      // console.log("Getting feature flags");

      setNavPath(path);
      setTenantId(tenantId);
      setAccessDenied(access_denied);

      if (response.MFA == true) {
        showMFAWorkflow(response);
      } else {
        proceedLogin(response);
      }
    } else {
      // console.log("loginAsync FALSE Response", response);
      //log login failed on backend
      setLoader(false);
    }
  };

  return (
    <main className="bg-white">
      {announcement && announcement === true && (
        <div className="relative w-screen top-0">
          <NotificationBanner
            showClose={false}
            text={announcementText}
            color="emerald"
          />
        </div>
      )}
      {maintenance && maintenance === true && (
        <div
          className="bg-white z-50 h-full absolute top-0 bottom-0 left-0 right-0
        p-6"
        >
          <div className="flex flex-col md:flex-row h-full justify-around content-center">
            <div className="flex flex-col h-full justify-center content-center text-center w-full md:w-1/2">
              <h1 className="text-6xl font-semibold text-slate-800 mb-6">
                We're building something better!
              </h1>
              <p className="text-slate-600">
                At Breachlink, we know that you do your best work when we do
                ours. That's why we're performing a few hours of system
                maintenance. When we're back, we'll be better than ever!{" "}
              </p>
              <p className="mt-6">
                Need help right away? Email us at{" "}
                <a
                  href="mailto:support@breachlink.com"
                  className="text-brand-600 hover:text-primary-500"
                >
                  support@breachlink.com
                </a>
              </p>
            </div>
            <div className="flex flex-col h-full justify-center content-center text-center w-full md:w-1/2">
              <img
                className="h-full w-auto"
                src={MaintenanceImage}
                alt="Auth Decoration"
              />
            </div>
          </div>
        </div>
      )}
      {showMFA && showMFA === true && (
        <div className="">
          <LoginBackground />
          <main className="">
            <div className="relative md:flex justify-center">
              {/* Content */}
              <div className=" justify-center content-center">
                <div className="min-h-screen h-full flex flex-col content-center justify-center">
                  <LoginCard title="Let's make sure it's you">
                    {/* <div className="bg-white bg-white shadow-lg rounded-md border border-gray-200 max-w-sm mx-auto p-8 "> */}

                    <div className="mb-10">
                      We've emailed you a verification code that's good for 15
                      minutes. Check your email and enter your verification code
                      below:
                    </div>
                    {/* Form */}
                    {/* <form onSubmit={multiFactorAuth}> */}
                    <div className="space-y-4">
                      <div>
                        {/* <label
                    className="block text-sm font-medium mb-1"
                    htmlFor="password"
                  >
                    Verification Code
                  </label> */}
                        <Input
                          id="Otp"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          className="h-12 rounded w-full
                    focus:shadow-[inset_0px_0px_2px_0px_rgba(0,0,0,0.3)] focus:shadow-accent-500
                    border-gray-300 py-2 px-3 shadow-sm
                    hover:border-gray-400
                    focus:border-none  focus:ring-1 focus:ring-brand-500"
                          type="number"
                          autoComplete="off"
                          placeholder="Verification Code"
                        />
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-6 mb-4">
                      <Button
                        type="submit"
                        disabled={otp === undefined || otp === ""}
                        // class="btn bg-primary w-full hover:bg-primary-600 text-white mb-4"
                        fullWidth
                        audit={true}
                        action="Login"
                        size="lg"
                        color="secondary"
                        handleClick={multiFactorAuth}
                        // onClick={auth}
                      >
                        {" "}
                        Continue Login
                      </Button>
                    </div>
                    {/* </form> */}
                    <Button
                      // type="submit"
                      color="outline"
                      className="btn bg-white w-full text-primary-600"
                      fullWidth
                      handleClick={() => {
                        setShowMFA(false);
                        setLoader(false);
                        setLoginMessage("");
                        setOtp("");
                        setAccessDenied(false);
                        // setIsAuthenticated(false);
                        setLoginResponse(null);
                        setNavPath(null);
                        _auth.setUserProfile({});
                      }}
                    >
                      Cancel
                    </Button>

                    {/* Footer */}
                    {/* {passwordMatched === false && (
                  <div className="flex items-center justify-center mt-6 text-red-500 text-sm">
                    Please recheck your password.
                  </div>
                )} */}
                    {isAuthenticated === false && (
                      <div className="flex items-center justify-center mt-6 text-red-500 text-sm">
                        Check your code and try again.
                      </div>
                    )}
                    {/* <div className="pt-5 mt-6 border-t border-gray-200">
              <div className="text-sm">
                Don’t you have an account?{" "}
                <Link
                  className="font-medium text-primary-500 hover:text-primary-600"
                  to="/signup"
                >
                  Sign Up
                </Link>
              </div>
            </div> */}
                    {/* </div> */}
                  </LoginCard>
                </div>
              </div>
            </div>
          </main>
        </div>
      )}
      {!showMFA && (
        <div>
          {" "}
          {/* <div className="absolute opacity-80 top-0 z-40 bg-none max-w-sm px-4 py-3">
            <div className="flex flex-row justify-center content-center">
              <img width="80" className="mr-3 " src={Logo} />
              <span className="inline-flex text-2xl m-auto font-medium text-white">
                Breachlink{" "}
              </span>
            </div>
          </div> */}
          <LoginBackground />
          <div className=" relative grow-1 justify-center">
            {/* Content */}
            {/* <div className=" justify-center content-center"> */}
            {/*Removed divide-x below   */}
            <div className="grid grid-cols-1 lg:grid-cols-1 min-h-screen  flex grow-0 flex-col content-center justify-center">
              {/* Begin content split */}
              <div className=" flex flex-col h-screen justify-center content-center">
                {/* Left Side card*/}
                <div className=" flex flex-col h-screen justify-center content-center">
                  {/* Left Side card*/}
                  <LoginCard title="Sign in to your account">
                    <div className="max-w-sm mx-auto px-4 ">
                      <form onSubmit={auth}>
                        <div className="space-y-4">
                          <div>
                            <label
                              className="block text-sm font-medium mb-1 "
                              htmlFor="email"
                            >
                              Email Address
                            </label>
                            <Input
                              type="email"
                              placeholder="Work email address"
                              id="email"
                            />
                            {/* <input
                      id="email"
                      className="form-input rounded-md w-full 
                      focus:shadow-[inset_0px_0px_2px_0px_rgba(0,0,0,0.3)] focus:shadow-brand-500 
                      border-gray-300 py-2 px-3 shadow-sm
                      hover:border-gray-400
                      focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
                      type="email"
                    /> */}
                          </div>
                          <div>
                            <label
                              className="block text-sm font-medium mb-1"
                              htmlFor="password"
                            >
                              Password
                            </label>
                            <Input
                              type="password"
                              // className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                              // label="Work Email address"
                              placeholder="Password"
                              id="password"
                              autoComplete="on"
                            />
                            {/* <input
                      id="password"
                      // className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-primary-500 sm:text-sm"
                      className=" rounded-md w-full
                      focus:shadow-[inset_0px_0px_2px_0px_rgba(0,0,0,0.3)] focus:shadow-brand-500
                      border-gray-300 py-2 px-3 shadow-sm
                      hover:border-gray-400
                      focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
                      type="password"
                      autoComplete="on"
                    /> */}
                          </div>
                        </div>
                        <div className=" items-center justify-between mt-6">
                          {/* {loader ? (
                    <div class="flex justify-center items-center">
                      <img
                        className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full"
                        src={Spinner}
                        width="32"
                        height="32"
                        alt="loading.."
                      />
                    </div>
                  ) : ( */}
                          <div className="text-sm">
                            <div className="py-2">
                              By signing in, you agree to our{" "}
                              <a
                                href="https://www.breachlink.com/terms"
                                //open in new window
                                target="_blank"
                                className="font-extra-small text-brand-600 hover:text-primary-500"
                              >
                                {" "}
                                Terms and Conditions
                              </a>
                            </div>
                          </div>
                          <Button
                            enabled={!loader}
                            loader={loader}
                            type="submit"
                            // disabled
                            className="text-center items-center justify-center"
                            // rounded
                            disabled={maintenance && maintenance === true}
                            fullWidth
                            color="lime"
                            size="md"
                            // handleClick={null}
                          >
                            Sign in
                          </Button>
                          <div className="flex items-center justify-between mr-1 mt-5">
                            <Link
                              className="text-sm text-accent-500 underline hover:text-accent-700"
                              to="/forgot-password"
                              disabled={maintenance && maintenance === true}
                            >
                              Forgot Password
                            </Link>
                            <Link
                              className="text-sm text-brand-500  hover:text-accent-700"
                              to="/signup"
                              disabled={maintenance && maintenance === true}
                            >
                              Sign Up
                            </Link>
                          </div>
                        </div>
                        {error && (
                          <div className="flex items-center justify-center mt-6 text-red-500 text-sm">
                            {error}
                          </div>
                        )}
                      </form>

                      {/* Footer */}
                      {isAuthenticated === false && (
                        <div className="flex grow-0 items-center justify-center mt-6  text-red-500 text-sm">
                          {/* Username or password is incorrect. */}
                          {loginMessage}
                        </div>
                      )}
                    </div>
                  </LoginCard>
                </div>
                {/* Right Side */}
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default Signin;

async function validateAndProcess(history, tenantId, response, access_denied) {
  // Extract project and solicitation IDs from the URL
  let urlParts = history.location.state?.from.split("/");
  let projectIndex = urlParts.indexOf("project-details");
  let solicitationIndex = urlParts.indexOf("solicitation-details");
  let projectId = urlParts[projectIndex + 1];
  let solicitationId = urlParts[solicitationIndex + 1];

  try {
    // Get project details using the project ID
    let project = await Projects.getById({
      _id: projectId,
    });

    if (project) {
      // Validate project based on the tenant ID
      tenantId = project.tenantId;
      let tenantIndex = response.tenants.findIndex(
        (t) => t.tenantId._id === tenantId
      );

      if (tenantIndex == -1) {
        access_denied = true;
      }

      // If solicitation ID exists, get solicitations and validate the solicitation
      if (solicitationId) {
        const solicitations = await Solicitations.getByProjectId({
          projectId: projectId,
          tenantId: tenantId,
        });

        let solicitationIndexObj = solicitations.findIndex(
          (t) => t._id === solicitationId
        );

        if (solicitationIndexObj == -1) {
          access_denied = true;
        }
      }
    } else {
      // Handle the case when the project is not found
      console.error("Project not found.");
      access_denied = true;
    }
  } catch (error) {
    console.error("Error retrieving project:", error.message);
    // Handle the error, provide a meaningful response, or log it for debugging
    access_denied = true; // Set access_denied to true in case of an error
  }

  // Return the result, including tenantId and access_denied
  return { tenantId, access_denied };
}
